/**
 * http配置
 */

import axios from 'axios'
import querystring from 'querystring'
import store from './store'
import * as types from './types'
import router from './router'

// 从本地缓存中读取token
if (window.localStorage.getItem('token')) {
  store.commit(types.RESTORE, window.localStorage.getItem('user'))
}

// axios 配置
axios.defaults.timeout = 20000
// axios.defaults.baseURL = 'http://localhost:8080/sales_java/bbs/'
// 正式环境
axios.defaults.baseURL = 'http://39.108.4.123:8080/sale/bbs/'
// axios.defaults.baseURL = 'http://39.108.4.123:8089/sale/bbs/'

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers.Token = `${store.state.token}`
    }
    if (config.emulateJSON && config.data instanceof Object) {
      config.data = querystring.stringify(config.data)
    }
    return config
  },
  err => {
    return Promise.reject(err)
  })

// http response 拦截器
axios.interceptors.response.use(
  response => {
    if (response.data.status === 10003) {
      var nextPath = router.currentRoute.fullPath
      if (router.currentRoute.query && router.currentRoute.query.redirect) {
        nextPath = router.currentRoute.query.redirect
      }
      store.commit(types.LOGOUT)
      router.replace({
        name: 'login',
        params: {redirect: nextPath}
      })
      return response
    } else {
      return response
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit(types.LOGOUT)
          router.replace({
            name: 'login',
            params: {redirect: router.currentRoute.fullPath}
          })
      }
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response.data)
  })

export default axios



// WEBPACK FOOTER //
// ./src/common/js/http.js